/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  fixDecoderSize,
  fixEncoderSize,
  getAddressDecoder,
  getAddressEncoder,
  getBytesDecoder,
  getBytesEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Address,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
  type ReadonlyUint8Array,
} from '@solana/kit';

export type VestingAllocation = {
  beneficiary: Address;
  scheduleId: number;
  padding: ReadonlyUint8Array;
  totalAmount: bigint;
  releasedAmount: bigint;
};

export type VestingAllocationArgs = {
  beneficiary: Address;
  scheduleId: number;
  padding: ReadonlyUint8Array;
  totalAmount: number | bigint;
  releasedAmount: number | bigint;
};

export function getVestingAllocationEncoder(): FixedSizeEncoder<VestingAllocationArgs> {
  return getStructEncoder([
    ['beneficiary', getAddressEncoder()],
    ['scheduleId', getU8Encoder()],
    ['padding', fixEncoderSize(getBytesEncoder(), 7)],
    ['totalAmount', getU64Encoder()],
    ['releasedAmount', getU64Encoder()],
  ]);
}

export function getVestingAllocationDecoder(): FixedSizeDecoder<VestingAllocation> {
  return getStructDecoder([
    ['beneficiary', getAddressDecoder()],
    ['scheduleId', getU8Decoder()],
    ['padding', fixDecoderSize(getBytesDecoder(), 7)],
    ['totalAmount', getU64Decoder()],
    ['releasedAmount', getU64Decoder()],
  ]);
}

export function getVestingAllocationCodec(): FixedSizeCodec<
  VestingAllocationArgs,
  VestingAllocation
> {
  return combineCodec(
    getVestingAllocationEncoder(),
    getVestingAllocationDecoder(),
  );
}
